export default {
  computed: {
    isUserInProject() {
      return this.$store.getters["global/isUserInProject"];
    },
    isUserNotAuthed() {
      return this.$store.getters["global/isUserNotAuthed"];
    },
    isUserAuthedNotRegistered() {
      return this.$store.getters["global/isUserAuthedNotRegistered"];
    },
    getUserDisplayName() {
      if (this.$authService) {
        return this.$authService.getUserDisplayName();
      }

      return "";
    },
  },
  methods: {
    login() {
      if (this.isUserNotAuthed) {
        this.$authService.showSignin();
      }
      if (this.isUserAuthedNotRegistered) {
        this.$authService.showProjectReg();
      }
    },
    register() {
      if (this.isUserNotAuthed) {
        this.$authService.showSignup();
      }
      if (this.isUserAuthedNotRegistered) {
        this.$authService.showProjectReg();
      }
    },
    logout() {
      if (this.$authService) {
        this.$authService.logout();
      }
    },
    toggleMenu() {
      this.is_menu_opened = !this.is_menu_opened;
    },
  },
}